<template>
  <act-list title="活动专区" :search-act-type="0"></act-list>
</template>

<script>

import ActList from "@view/sales/activity/act-list.vue";

export default {
  name: "list",
  components: {ActList},
  data() {
    return {}
  },
  mixins: [tableBase],
  methods: {},
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
